import { ManageBlacklistPage } from '@online-webinar/management';
import { RouterType } from '@online-webinar/router';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/manage/blacklist'].update({
        staticData: { title: { page: 'Blacklist.PageHeading' } },
        component: authGuard(ManageBlacklistPage, { canManageBlacklist: true })
    });
};
